import { SET_LIST_TEACHER } from './teacherConst';

export function setListTeacher(teacher) {
  return {
    type: SET_LIST_TEACHER,
    teacher
  };
}
